import React from 'react';
import {MultiList} from "@appbaseio/reactivesearch";

const Assays = () => {
    return (<MultiList
        componentId="Assay"
        dataField="Assay.keyword"
        className="genres-filter"
        size={20}
        sortBy="asc"
        queryFormat="or"
        // selectAllLabel="All Assays"
        showCheckbox={true}
        showCount={true}
        showSearch={false}
        // placeholder="Select assay"
        react={{
            and: [
                // "Age", "Tissue", "Exposure", "Lab", "Search", "Experiment", "Sex"
                "Condition", "Lab", "Search"
            ]
        }}
        // showFilter={true}
        filterLabel="Assay"
        URLParams={true}
        innerClass={{
        label: "list-item",
        input: "list-input"
    }}/>);
}

export default Assays;